module.exports = __webpack_public_path__ + "media/images/payment/logo_familymart-38097628ab92ac39b83b6700a6b321ca.gif";